import { Component, Inject } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ParcoursFormationService } from 'src/services/parcours-formation.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-delete-parcours-formation-dialog',
    imports: [MatDialogModule, TranslateModule],
    templateUrl: './delete-parcours-formation-dialog.component.html',
    styleUrls: ['./delete-parcours-formation-dialog.component.scss']
})
export class DeleteParcoursFormationDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<DeleteParcoursFormationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { parcoursFormationId: number },
    private parcoursFormationService: ParcoursFormationService,
    private snackBar: MatSnackBar,
    private translateService: TranslateService
  ) { }

  confirmerSuppression(): void {
    this.parcoursFormationService.supprimerParcoursFormation(this.data.parcoursFormationId).subscribe({
      next: () => {
        this.translateService.get('LEARNING_PATH_MANAGEMENT.DELETION_SUCCESSFUL').subscribe(message => {
          this.snackBar.open(message, 'OK', { duration: 3000 });
        });
        this.dialogRef.close(true);
      },
      error: () => {
        this.translateService.get('LEARNING_PATH_MANAGEMENT.DELETION_ERROR').subscribe(message => {
          this.snackBar.open(message, 'OK', { duration: 3000 });
        });
        this.dialogRef.close(false);
      }
    });
  }

  annuler(): void {
    this.dialogRef.close(false);
  }
}
